import { BorrowHistorySearchFlag } from '@/api'
// TODO jobディレクトリに配置しておくように

export interface CreateInterLibraryLoanBorrowListRequest {
  searchFlag: BorrowHistorySearchFlag
  borrowingDate: string
  borrowingDateFrom: string
  borrowingDateTo: string
  interlibraryLoanCode: string
}

export function CreateInterLibraryLoanBorrowListRequestToJSON(
  value: CreateInterLibraryLoanBorrowListRequest
): any {
  return {
    search_flag: value.searchFlag ? value.searchFlag : undefined,
    borrowing_date:
      value.borrowingDate !== '' ? value.borrowingDate : undefined,
    borrowing_date_from:
      value.borrowingDateFrom !== '' ? value.borrowingDateFrom : undefined,
    borrowing_date_to:
      value.borrowingDateTo !== '' ? value.borrowingDateTo : undefined,
    interlibrary_loan_code:
      value.interlibraryLoanCode !== '' ? value.interlibraryLoanCode : undefined
  }
}
